export default "/provider/admin/images/icon-controllers2.jpeg?cba76c74623d85bb247d62d2eb0bd220";